import { compose } from 'redux';
import { connect } from 'react-redux';
import OwlyInterstitialView from './OwlyInterstitialView';
import { completeAssessment } from '../start/startActions';
import { blockScreen, unblockScreen } from '../screen/screenActions';
import { playAudio } from '../audio/audioActions';
import { goToDonePage } from '../navigation/navigationActions';
import owlyCelebrationAudio from '../../sounds/owlyCelebrationAudio.mp3';
import { startPlaying, stopPlaying } from '../stimulus/stimulusButtonActions';
import withAvatar from '../avatar/withAvatar';
import AvatarView from '../avatar/avatarView';

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.HIDDEN,
});

const mapDispatchToProps = dispatch => {
    const onAudioPlay = () => dispatch(startPlaying());
    const onAudioEnd = () => {
        dispatch(stopPlaying());
        dispatch(unblockScreen());
        dispatch(goToDonePage());
    };
    return {
        goToNextPage: () => dispatch(completeAssessment()),
        playAudio: () => {
            dispatch(blockScreen());
            dispatch(playAudio([owlyCelebrationAudio], 0, onAudioPlay, onAudioEnd));
        },
    };
};

const OwlyInterstitialContainer = compose(
    connect(null, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(OwlyInterstitialView);

export default OwlyInterstitialContainer;
